import { Box } from "@mui/material";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";

import { tokens } from "../../../../theme";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { HRService } from "../../../../config";
import { useTheme } from "@emotion/react";
import PayrollRunCreationForm from "../form";
import { PayrollColumns } from "../../../../data/Columns/hrmanagement";


const base_url = HRService.uri;

const PayrollPendingApprovalTable = () => {
  const actions = {
    entity: "Payroll",
    // edit: {
    //   key: "EDIT",
    //   button_name: "Edit",
    //   Show_Button: true,
    //   permission: "EditPermission",
    // },
    // add: {
    //   key: "ADD",
    //   button_name: "Add",
    //   Show_Button: true,
    //   permission: "CreatePermission",
    //   inputObjectName: "createCaseDynamic",
    //   InputObject: "newCase",
    // },
    // activateDeactivate: {
    //   key: "ACTIVATEDEACTIVATE",
    //   button_name: "Deactivate",
    //   Show_Button: false,
    //   permission: "ActivatePermission",
    // },
    ViewPayrollLines: {
      key: "VIEWPAYROLLLINES",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },

     // ---------- APPROVE ----------
  APPROVEPAYROLL: {
    key: "ApprovePayroll",
    button_name: "Approve Payroll",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  modelName: "allPayrollRunsPendingApproval", 
         dataObject: {
             // *** UPDATE: The input field must match the GraphQL variable (feeNotesLines) ***
             inputFields: {
                approverUserId: null,
            },
             
             // *** UPDATE: inputObjectName matches the GraphQL operation name (without 'query') ***
             inputObjectName: "allPayrollRunsPendingApproval", 
             
             // *** UPDATE: inputSubObjectName is the array of results returned by the operation ***
             // Assuming the results array is directly returned by the operation.
             // If the API nests the array under another field, change this accordingly.
             inputSubObjectName: "parameters", // Often the same as inputObjectName if the array is directly returned.
             
            returnFields: [
           "id",
    "companyId",
    "countryId",
    "periodName",
    "periodStart",
    "periodEnd",
    "payDate",
    "runType",
    "status",
    "totalEmployees",
    "totalGross",
    "totalNet",
    "createdBy",
    "createdAt",
    "approvedBy",
    "approvedAt",
    "isOpen",
        ]
         },
  

    showStatus: true,
  };
  const [data, setData] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

 
  return (
    <Box m="2px">
      <>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          
        </Box>
        <DynamicTable
          title="Payroll"
          subtitle="View all Payroll, create or update a employee"
          columns={PayrollColumns}
          FormComponent={PayrollRunCreationForm}
          //query={AllPayrollQuery}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
};

export default PayrollPendingApprovalTable;
